import ReducerBuilder from "classes/ReducerBuilder";
import {Types} from './actions';
import initialState from './initialState';

const reducer = ReducerBuilder.make(initialState)
    .forType(Types.START_LEAD_GEN_FIELD_PICK)
    .reduce((state, action) => {
        state.picking = true;
        state.brk = action.brk;
        state.pickingForLeadGen = action.leadGen;
        state.resourcePath = action.resourcePath;
        state.fieldPath = action.fieldPath;
    })
    .forType(Types.END_LEAD_GEN_PICK)
    .reduce((state) => {
        state.picking = false;
        state.pickingForLeadGen = null;
        state.resourcePath = null;
        state.fieldPath = null;
    })
    .build();

export default reducer;


// WEBPACK FOOTER //
// ./public/pages/LeadGenFieldPicker/reducer.js